export const pageWorker = new Worker('/worker.js')
